<tokens-browser-logout (registerBrowser)="onRegisterBrowser()" (cancel)="onCancel()"></tokens-browser-logout>
